var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Graph, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bar_chart_4_bars",
    d: "M3.20656 21.0405V19.0405H23.2066V21.0405H3.20656ZM4.20656 18.0405V11.0405H7.20656V18.0405H4.20656ZM9.20656 18.0405V6.04053H12.2066V18.0405H9.20656ZM14.2066 18.0405V9.04053H17.2066V18.0405H14.2066ZM19.2066 18.0405V3.04053H22.2066V18.0405H19.2066Z",
    fill: "#707B8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.7ce8b43a6d341d512cb55908daf48843.svg";
export { ForwardRef as ReactComponent };